import React from 'react';
import { GetInTouch } from './fragments';
import { contactOptions } from './fragments/constants';

export const ContactUs = () => {
    return (
        <div className="contact-us-page-wrapper">
            <div className="contact-us-page">
                <div>
                    <p className="contact-us-title">Contact Information</p>
                    <p className="contact-us-description">Our team is here to answer questions and guide you to the right direction.</p>

                    {contactOptions.map(({ Icon, details, label, title, subTitle }, index) => (
                        <div className="social-contact-us-items" key={index}>
                            <Icon className="social-contact-us-svg" />

                            <div className="flex-column-start">
                                <p>{title}</p>
                                <span>{subTitle}</span>
                                <a rel="noopener noreferrer" target="_blank" href={details}>
                                    {label}
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <GetInTouch />
        </div>
    );
};
